module.exports = __webpack_public_path__ + "img/a_frutos_secos.b143f184.svg";